export default {
  BASE_URL: '/gsa',
  api: [
    {
      name: 'category',
      desc: '分类',
      method: 'GET',
      path: '/category',
      mock: true
    },
    {
      name: 'list',
      desc: '列表',
      method: 'GET',
      path: '/list',
      mock: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/cms/mock.js